<template>
  <v-layout mt-4 child-flex>
    <Table
      table-title="Orders Table"
      :headers="ordersTableHeaders"
      :items="orders"
      icon="domain"
      :actions="actions"
      :items-per-page="20"
      primaryActionText="New Order"
      primaryActionIcon="add"
      @primary-action-event="gotoNewOrder"
    />
  </v-layout>
</template>

<script>
import request from "@/modules/request";
import Table from "@/components/Table";
import moment from "moment";
import { hasPermission } from "@/modules/rbac/permission-manifest";

export default {
  name: "UserOrders",
  inject: ["snackBar", "reactiveInjected"],
  async mounted() {
    await this.getOrders();
  },
  components: {
    Table,
  },
  data() {
    return {
      canCreateOrder: hasPermission(
        "canCreateOrder",
        null,
        this.reactiveInjected.activeUser
      ),
      loading: true,
      orders: [],
      ordersTableHeaders: [
        {
          text: "Order ID",
          value: "orderId",
        },
        {
          text: "PO #",
          value: "poNum",
        },
        {
          text: "Order Date",
          value: "orderDate",
        },
        {
          text: "Status",
          value: "orderStatus",
        },
        {
          text: "Order Total",
          value: "formattedOrderTotal",
        },
        {
          text: "",
          value: "action",
        },
      ],
      actions: [
        {
          color: "primary",
          click: this.viewOrder,
          text: "View",
        },
      ],
    };
  },
  methods: {
    gotoNewOrder() {
      this.$router.push({
        name: "UserCreateOrder",
      });
    },
    async getOrders() {
      const results = await request.callInternal({
        method: "get",
        route: "/api/orders",
      });
      this.formatOrders(results.data);
    },
    formatOrders(orders) {
      const formattedOrders = orders.map((order) => {
        order.orderDate = moment(order.createdAt).format("MM-DD-YYYY");
        return order;
      });
      this.orders = formattedOrders;
      this.loading = false;
    },
    viewOrder(order) {
      this.$router.push({
        name: "UserOrder",
        params: {
          id: order._id,
        },
      });
    },
  },
};
</script>
